<app-page-meta pageTitle="finzy - Investment Application"></app-page-meta>
<app-header></app-header>
<div class="row mainrow">
  <div class="col-sm-4 leftdiv">
    <app-lenderleftdiv></app-lenderleftdiv>
  </div>
  <div class="col-sm-8 rightdiv">
    <div class="mobileleftdiv">
      <app-lender-registration-progress-bar></app-lender-registration-progress-bar>
    </div>
    <div class="rightinnerdiv">
      <form (keydown.enter)="$event.preventDefault()" #form="ngForm" (ngSubmit)="submitPersonalInfo()" method="post">
        <p class="headtxt">Tell us about yourself</p>

        <div class="radio-toolbar">
          <div *ngFor="let gender of genders">
            <input type="radio" id="{{gender.id}}" required name="genderdetail" [disabled]="isLoanApplicationSubmitted"
                   [(ngModel)]="genderdetail" (click)="onChangeGender(gender.value)" [value]="gender.value">
            <label [ngClass]="genderError ? 'error-switch': ''" for="{{gender.id}}">{{gender.display}}</label>
          </div>
        </div>
        <span *ngIf="genderError" class="errormsg">Please select the gender</span>
        <p class="txt1">Date of birth</p>

        <mat-form-field class="example-full-width">
          <input matInput placeholder="DD/MM/YYYY" [matDatepicker]="picker" required name="dob" [(ngModel)]="dob"
                 [max]="maxDate" [min]="minDate" [disabled]="dobDisabled || isLoanApplicationSubmitted">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <span *ngIf="dateError" class="errormsg">Please provide a valid date of birth</span>

        <p class="txt3">Permanent address</p>

        <mat-form-field style="width: 100%">
          <input matInput type="text" placeholder="Please provide an address for which you have a readily available address proof"
                 [disabled]="addrDisabled" [(ngModel)]="address" maxlength="100" ng-reflect-required="true" required
                 name="address">
        </mat-form-field>
        <div class="row">
          <div class="col-sm-4">

            <mat-form-field style="width: 100%;margin-top: 10px;">
              <input matInput type="text" placeholder="City" [disabled]="cityDisabled" [(ngModel)]="city" maxlength="25"
                     ng-reflect-required="true" required name="city">
            </mat-form-field>

            <span *ngIf="cityError" class="errormsg">Please fill out city</span>
          </div>
          <div class="col-sm-4 stateDiv">

            <mat-form-field style="width:100%;">
              <mat-select placeholder="Select state" name="state" [disabled]="stateDisabled" [(ngModel)]="state"
                          ng-reflect-required="true" required>
                <mat-option *ngFor="let s of states" [value]="s.state_name" required>
                  {{ s.state_name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span *ngIf="stateError" class="errormsg">Please fill out state</span>
          </div>
          <div class="col-sm-4">
            <mat-form-field style="width: 100%;margin-top: 10px;">
              <input matInput type="text" pattern="[0-9]{6}" [disabled]="pinDisabled" ng-reflect-required="true"
                     (keyup)="onPinInput($event)" title="Please enter only numbers" maxlength="6" placeholder="Pincode"
                     [(ngModel)]="pincode_num" required name="pincode_num">
            </mat-form-field>
            <span *ngIf="pincodeError" class="errormsg2">Please fill out pincode</span>

          </div>
        </div>

        <div class="row buttondiv">
          <div class="col-sm-6 backbtn">
            <button mat-stroked-button class="button-back primary" [routerLink]="['/invest/email-verification']"><i class="material-icons">arrow_back</i>&nbsp;&nbsp;&nbsp;
              BACK
            </button>
          </div>
          <div class="col-sm-6 moveright">
            <app-forward-button class="button-forward" [isLoading]="loaderStatus.isLoading" (click)="analyticsTracker.trackButtonClick('Lender Personal Information','NEXT')">
              NEXT
            </app-forward-button>

          </div>
        </div>
      </form>
    </div>
  </div>
</div>


<app-footer></app-footer>




